<template>
    <svg :width="width" :height="height" viewBox="0 0 24 24"
         xmlns="http://www.w3.org/2000/svg">
        <circle class="spinner" cx="4" cy="12" r="3" :fill="color"/>
        <circle class="spinner" cx="4" cy="12" r="3" :fill="color"/>
        <circle class="spinner" cx="4" cy="12" r="3" :fill="color"/>
        <circle class="spinner" cx="4" cy="12" r="3" :fill="color"/>
    </svg>
</template>

<script>
import {defineComponent} from "vue";
// spinner source: https://github.com/n3r4zzurr0/svg-spinners/blob/main/svg-css/3-dots-move.svg

export default defineComponent({
    name: 'SpinnerElement',
    props: {
        height: {
            type: Number,
            required: false,
            default: 24
        },
        width: {
            type: Number,
            required: false,
            default: 24
        },
        color: {
            type: String,
            required: false,
            default: '#000000'
        }
    },
    setup() {
        return {}
    }
})
</script>

<style scoped lang="scss">
.spinner {
    animation: spinnerAnimation 2s cubic-bezier(0.36, .6, .31, 1) infinite
}

svg > circle.spinner:nth-of-type(2) {
    animation-delay: -.5s
}

svg > circle.spinner:nth-of-type(3) {
    animation-delay: -1s
}

svg > circle.spinner:nth-of-type(4) {
    animation-delay: -1.5s
}

@keyframes spinnerAnimation {
    0% {
        r: 0
    }
    25% {
        r: 3px;
        cx: 4px
    }
    50% {
        r: 3px;
        cx: 12px
    }
    75% {
        r: 3px;
        cx: 20px
    }
    100% {
        r: 0;
        cx: 20px
    }
}
</style>